<template>
    <div class="panel-body" id="create-review">
        <template v-if="orders.length && !loadingOrders">
            <div v-if="newReview" class="review-form text-white">
                <form id="submit_review" action="/users/submit-review" method="post">
                    <div class="form-containers col-xs-12 col-md-8">
                        <div class="form-group col-xs-12 p-a-0 m-b-md">
                            <multiselect
                                id="build"
                                class="multiselect"
                                data-vv-validate-on="change"
                                data-vv-as="build"
                                v-model.trim="selectedOrder"
                                name="build"
                                :options="orders"
                                :class="{'border-danger': errors.has('build')}"
                                :allow-empty="false"
                                label="bld_number"
                                placeholder="BUILD"
                                :show-labels="false">
                                <template slot="singleLabel" slot-scope="props">
                                    BUILD{{ props.option.bld_number ? ': ' + props.option.bld_number : '' }}
                                </template>

                                <template slot="option" slot-scope="props">
                                    BUILD: {{ props.option.bld_number }}<br>
                                    CPU: {{ getElementInArray(props.option.details, 'product_modules_id', "3", "name") }}<br>
                                    GPU: {{ getElementInArray(props.option.details, 'product_modules_id', "7", "name") }}
                                </template>
                            </multiselect>

                            <i v-show="showWarning && !selectedOrder.id" class="fa fa-warning is-danger" />
                            <span v-show="showWarning && !selectedOrder.id" class="is-danger">
                                You should select a build
                            </span>
                        </div>
                        <div class="form-group col-xs-12 p-a-0 m-b-md">
                            <div class="field-title">
                                <label for="description">Description</label>
                                <textarea
                                    autofocus
                                    name="description_review"
                                    v-validate="'required|min:30'"
                                    :class="{'input': true, 'is-danger': errors.has('description_review') }"
                                    type="text"
                                    data-vv-as="description of the review"
                                    data-vv-validate-on="change"
                                    v-model.trim="description"
                                    class="form-control"
                                    id="description" />
                                <span v-show="errors.has('description_review')" class="help is-danger">
                                    <i class="fa fa-warning is-danger" />
                                    {{ errors.first('description_review') }}
                                </span>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 p-a-0">
                            <label for="rating">Rating</label>
                            <div class="pull-right clearfix">
                                <star-rating
                                    v-model="rating"
                                    active-color="#640a92"
                                    inactive-color="#5f686d"
                                    :star-size="30"
                                    :show-rating="false"
                                    :increment="0.5" />
                            </div>
                        </div>
                    </div>
                    <div class="clearfix" />
                    <button
                        :disabled="creatingReview"
                        @click="validateForm()"
                        class="btn btn-sm btn-round btn-green pull-right"
                        type="button">
                        {{ creatingReview ? "SUBMITING..." : "SUBMIT" }}

                        <template v-if="creatingReview">
                            <i class="fa fa-spin fa-spinner" />
                        </template>
                        <template v-else>
                            <i class="fa fa-long-arrow-right" />
                        </template>
                    </button>
                </form>
            </div>
            <div v-else class="success-review text-white">
                <div class="form-group col-xs-12 p-a-0 clearfix">
                    <div class="col-xs-12">
                        <h2>Thanks for your Review</h2>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="!orders.length && !loadingOrders">
            <div class="text-center">
                <h4 class="text-white m-b-md">
                    You have not made a purchase from LETSBLD.com yet!
                </h4>
                <router-link class="btn btn-sm btn-round btn-green" to="/bld">
                    GO TO BLD
                    <i class="fa fa-long-arrow-right" aria-hidden="true" />
                </router-link>
            </div>
        </template>
        <template v-if="loadingOrders">
            <div style="text-align:center">
                <span class="fa fa-spin fa-spinner" />
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "CreateReview",
    props: {
        newReview: {
            type: Boolean
        }
    },
    data() {
        return {
            description: "",
            loadingOrders: true,
            orders: [],
            rating: 4,
            selectedOrder: {},
            showWarning: false,
            creatingReview: false
        };
    },
    created() {
        this.getOrders();
    },
    methods: {
        create() {
            this.creatingReview = true;

            axios({
                url: "/reviews",
                method: "POST",
                data: this.prepareFormData()
            }).then(() => {
                this.cleanForm();
                this.$emit("newReview");
            }).catch(error => {
                toastr.error(error.response.data.status.message, "Error", { timeOut: 5000 });
            }).finally(() => {
                this.creatingReview = false;
            });
        },
        cleanForm() {
            this.description = "";
            this.selectedOrder = {};
            this.rating = 4;
            this.showWarning = false;
        },
        getOrders() {
            axios({
                url: "/users/0/orders",
                method: "GET"
            }).then(orders => {
                this.orders = orders.data;
                this.loadingOrders = false;
                this.showWarning = false;
            }).catch(() => {});
        },
        getElementInArray(array, comparisionProperty, value, property) {
            const filteredElement = array.find(element => element[comparisionProperty] == value);
            if (filteredElement && filteredElement[property]) {
                return filteredElement[property];
            }
            return "-";
        },
        prepareFormData() {
            const formData = new FormData();
            formData.append("description", this.description);
            formData.append("orders_id", this.selectedOrder.id);
            formData.append("rating", this.rating);

            return formData;
        },
        async validateForm() {
            const isValidForm = await this.$validator.validateAll();
            if (!isValidForm) {
                return;
            } else if (!this.selectedOrder.id) {
                this.showWarning = true;
            } else {
                if (!this.creatingReview) {
                    this.create();
                }
            }
        }
    }
}
</script>

<style lang="scss">
@import '~@s/_asset-mixers.scss';

#create-review {
    @media (min-width: 991px) {
        textarea {
            height: 300px !important;
        }

        .field-title {
            width: 550px;
        }
    }

    @media (min-width: 320px) and (max-width: 990px) {
        textarea {
            height: 150px !important;
        }
    }

    .multiselect {
        height: 48px;
        cursor: pointer;

        .multiselect__select {
            height: 48px;
            padding: 10px 8px;
        }

        .multiselect__tags {
            height: 48px;
            padding: 13px 40px 0 10px;
            border-radius: 4px;
            box-shadow: 0 0 0 2px $purple inset;
            border: 0;
            margin-bottom: -1px;

            .multiselect__placeholder {
                padding-top: 0;
            }

            .multiselect__fake-placeholder {
                padding-top: 0;
                color: black;
                display: inline-block;
                margin-bottom: 10px;
            }
        }

        .multiselect__option {
            color: black;
        }

        .multiselect__option--highlight {
            background-color: $purple;
            color: black;
        }

        .multiselect__option--selected,
        .multiselect__option--highlight {
            box-shadow: 2px 0 0 0 $purple inset, -2px 0 0 0 $purple inset;
        }

        .multiselect__content-wrapper {
            box-shadow: 0 0 0 2px $purple inset;

            .multiselect__option {
                min-height: 32px;
                padding: 8px 12px;
            }
        }

        &.border-danger {
            .multiselect__tags {
                box-shadow: 0 0 0 2px #e63a37 inset !important;
            }
        }
    }
}
</style>
